/**
 * Auto-format a phone number as user types: (555) 123-4567
 * Strips non-digit characters, then applies US phone format.
 * Returns the formatted string for display in input fields.
 */
export function formatPhoneInput(value) {
  if (!value) return "";
  const digits = value.replace(/\D/g, "");
  
  // Remove leading "1" country code if they type it
  const cleaned = digits.length > 10 && digits.startsWith("1") ? digits.slice(1) : digits;
  
  if (cleaned.length === 0) return "";
  if (cleaned.length <= 3) return `(${cleaned}`;
  if (cleaned.length <= 6) return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3)}`;
  return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(6, 10)}`;
}

/**
 * Format a stored phone number for display: (555) 123-4567
 */
export function formatPhoneDisplay(phone) {
  if (!phone) return "";
  const digits = phone.replace(/\D/g, "");
  const cleaned = digits.length === 11 && digits.startsWith("1") ? digits.slice(1) : digits;
  if (cleaned.length !== 10) return phone;
  return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(6)}`;
}

/**
 * Extract raw digits from a formatted phone number.
 * Returns 10-digit US phone number string (no country code).
 */
export function extractPhoneDigits(phone) {
  if (!phone) return "";
  const digits = phone.replace(/\D/g, "");
  if (digits.length === 11 && digits.startsWith("1")) return digits.slice(1);
  return digits.slice(0, 10);
}

/**
 * Validate a phone number has 10 digits.
 */
export function isValidPhone(phone) {
  if (!phone) return false;
  const digits = phone.replace(/\D/g, "");
  const cleaned = digits.length === 11 && digits.startsWith("1") ? digits.slice(1) : digits;
  return cleaned.length === 10;
}
